import React from "react"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody, FontIcon } from "material-ui"
import strings from "../../../localization/strings"
import Table from "../../../components/common/Table"
import { IJobDocument } from "../../../models"
import { green500, red500 } from "material-ui/styles/colors"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import AccountStore from "../../../stores/AccountStore"
interface IProps {
	readonly: boolean
	jobs: IJobDocument[]
	selectedJobs: IJobDocument[]
	total: number
	offset: number
	limit: number
	limitOptions: number[]
	onPageClick(offset: number): void
	onLimitChange(limit: number): void
	handleClickRow(jobId: string): void
	handleSelectJobs(jobs: IJobDocument[]): void
}

const ClientJobsTable: React.SFC<IProps> = (props: IProps) => {
	return (
		<Table
			readonly={props.readonly}
			allowClickRow
			items={props.jobs}
			handleSelect={props.handleSelectJobs}
			handleClickRow={job => props.handleClickRow(job.Id)}
			total={props.total}
			offset={props.offset}
			limit={props.limit}
			limitOptions={props.limitOptions}
			onPageClick={props.onPageClick}
			onLimitChange={props.onLimitChange}
		>
			<TableHeader>
				<TableRow>
					<TableHeaderColumn style={{ textAlign: "left", width: "auto", paddingLeft: 5, paddingRight: 5 }}>{strings.Name}</TableHeaderColumn>
					<TableHeaderColumn style={{ textAlign: "left", paddingLeft: 5, paddingRight: 5 }}>{strings.Parent_Hierarchy}</TableHeaderColumn>
					{AccountStore.getPhasesEnabled() &&
						<TableHeaderColumn style={{ textAlign: "left", width: 100, paddingLeft: 5, paddingRight: 5 }}>{strings.Phases}</TableHeaderColumn>
					}
					<TableHeaderColumn style={{ textAlign: "center", width: 80, paddingLeft: 5, paddingRight: 5 }}>{strings.Active}</TableHeaderColumn>
				</TableRow>
			</TableHeader>
			<TableBody deselectOnClickaway={false}>
				{props.jobs.map(job => {
					const hierarchyPathLabelToRoot = hierarchyHelper.getFullPathLabel(job.HierarchyId)
					return (
						<TableRow key={job.Id} selected={props.selectedJobs.find(item => item.Id === job.Id) ? true : false}>
							<TableRowColumn style={{ textAlign: "left", cursor: "pointer", width: "auto", paddingLeft: 5, paddingRight: 5 }} title={job.Name}>
								{job.Name}
							</TableRowColumn>
							<TableRowColumn style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5, color: hierarchyPathLabelToRoot === strings.Hierarchy_Removed && red500 }} title={hierarchyPathLabelToRoot === strings.Hierarchy_Removed ? "" : hierarchyPathLabelToRoot}>
								{hierarchyPathLabelToRoot}
							</TableRowColumn>
							{AccountStore.getPhasesEnabled() &&
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer", width: 100, paddingLeft: 5, paddingRight: 5 }}>
									{job.Phases.length}
								</TableRowColumn>
							}
							<TableRowColumn style={{ textAlign: "center", cursor: "pointer", width: 80, paddingLeft: 5, paddingRight: 5 }}>
								{job.Active &&
									<FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
								}
							</TableRowColumn>
						</TableRow>
					)
				})}
			</TableBody>
		</Table>
	)
}

export default ClientJobsTable